import { createStore } from 'vuex'

export default createStore({
  state: {
		userid:sessionStorage.getItem('userid'),
		token:sessionStorage.getItem('token')
  },
  mutations: {
		setVuex(state,data){//设置token
			state.token = data.token
			state.userid = data.student.id
			sessionStorage.setItem('token',data.token)
			sessionStorage.setItem('userid',data.student.id)
		}
  },
  actions: {
  },
  modules: {
  }
})
